import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";
import Accessibility from "highcharts/modules/accessibility";
import OfflineExporting from "highcharts/modules/offline-exporting";

// Initialize optional modules against the same Highcharts instance.
HighchartsMore(Highcharts);
Exporting(Highcharts);
ExportData(Highcharts);
Accessibility(Highcharts);
OfflineExporting(Highcharts);

// Preserve existing app behavior that relies on window.Highcharts.
window.Highcharts = Highcharts;
